<template>
  <MoleculeButtonBack
    :label="t_('back-to-event-overview-label')"
    :flush="false"
    :background-color="theme ? `t-cdp-button-bg-${theme}` : 'bg-app-secondary-8-green--vista-blue'"
    :text-color="theme ? `t-cdp-button-text-${theme}` : 'text-app-primary-1-red--torch'"
    @click="backToEventOverview()"
  />
</template>

<script setup lang="ts">
import { explodeUrl } from '@/assets/link'

defineProps({
  theme: { type: String, required: true },
})

const { t_ } = setupTranslationPrefixer('event-detail')
const eventOverviewStore = useEventOverviewStore()
const globalStore = useGlobalStore()
const router = useRouter()

function backToEventOverview() {
  const query = eventOverviewStore.urlParameters
  const path = explodeUrl(globalStore.eventOverview?.url || '').path
  router.push({ path, query })
}
</script>
